import { jsx as _jsx } from "react/jsx-runtime";
export function Delete({ onClick }) {
    return _jsx("button", { className: "delete", onClick: onClick });
}
//# sourceMappingURL=Delete.js.map